import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reviews-management',
  templateUrl: './reviews-management.component.html',
  styleUrls: ['./reviews-management.component.scss']
})
export class ReviewsManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
